<div class="properties-container bg-gray-50 min-h-screen">
  <!-- Compact Header -->
  <section class="bg-gradient-to-r from-immovea-navy via-blue-800 to-blue-900 text-white py-8 sm:py-12 lg:py-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-3xl font-bold mb-1">Browse Properties</h1>
          <p class="text-sm text-blue-100">{{ filteredProperties.length }} {{ filteredProperties.length === 1 ? 'property' : 'properties' }} available</p>
        </div>
        <!-- Mobile Filter Toggle -->
        <button 
          (click)="toggleMobileFilters()"
          aria-label="Toggle filter panel"
          class="lg:hidden px-4 py-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg font-semibold transition flex items-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
          </svg>
          Filters
        </button>
      </div>
    </div>
  </section>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
    <div class="flex flex-col lg:flex-row gap-6">
      <!-- Sidebar Filters -->
      <aside 
        [class.hidden]="!showMobileFilters()"
        class="lg:block w-full lg:w-72 flex-shrink-0">
        
        <div class="bg-white rounded-xl shadow-md sticky top-4 max-h-[calc(100vh-6rem)] flex flex-col">
          <!-- Header (Fixed) -->
          <div class="flex items-center justify-between p-5 pb-4 border-b flex-shrink-0">
            <h2 class="text-lg font-bold text-gray-900 flex items-center gap-2">
              <svg class="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
              </svg>
              Filters
            </h2>
            <button 
              (click)="clearFilters()"
              aria-label="Clear all filters"
              class="text-xs text-red-600 hover:text-red-700 font-semibold">
              Clear All
            </button>
          </div>

          <!-- Scrollable Content -->
          <div class="overflow-y-auto flex-1 p-5 space-y-5 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">

          <!-- Listing Type -->
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">Listing Type</label>
            <div class="flex flex-col gap-2">
              <button
                (click)="setListingTypeFilter('all')"
                aria-label="Show all properties"
                [class]="listingTypeFilter() === 'all' 
                  ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
                class="px-4 py-2.5 rounded-lg font-semibold transition text-sm text-left flex items-center gap-2">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                </svg>
                All Properties
              </button>
              <button
                (click)="setListingTypeFilter('sale')"
                aria-label="Filter properties for sale"
                [class]="listingTypeFilter() === 'sale' 
                  ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
                class="px-4 py-2.5 rounded-lg font-semibold transition text-sm text-left flex items-center gap-2">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                For Sale
              </button>
              <button
                (click)="setListingTypeFilter('rent')"
                aria-label="Filter properties for rent"
                [class]="listingTypeFilter() === 'rent' 
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
                class="px-4 py-2.5 rounded-lg font-semibold transition text-sm text-left flex items-center gap-2">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                </svg>
                For Rent
              </button>
            </div>
          </div>

          <!-- Favorites Filter -->
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">Favorites</label>
            <button
              (click)="toggleFavoritesFilter()"
              [class]="showFavoritesOnly() 
                ? 'bg-gradient-to-r from-red-500 to-pink-500 text-white' 
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'"
              class="w-full px-4 py-2.5 rounded-lg font-semibold transition text-sm text-left flex items-center justify-between">
              <span class="flex items-center gap-2">
                <svg class="w-5 h-5" [class.fill-current]="showFavoritesOnly()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
                Show Favorites Only
              </span>
              <span class="text-xs px-2 py-1 rounded-full" 
                    [class]="showFavoritesOnly() ? 'bg-white bg-opacity-20' : 'bg-gray-200'">
                {{ favoritesService.getFavoriteCount() }}
              </span>
            </button>
          </div>

          <!-- Property Type -->
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">Property Type</label>
            <select 
              [(ngModel)]="propertyTypeFilter" 
              (change)="setPropertyTypeFilter($any($event.target).value)"
              class="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-gray-900 text-sm">
              <option value="all">All Types</option>
              <option value="Apartment">🏢 Apartment</option>
              <option value="Villa">🏡 Villa</option>
              <option value="Land">🌳 Land</option>
              <optgroup label="🏪 Commercial">
                <option value="Commercial - Office">📋 Office</option>
                <option value="Commercial - Warehouse">📦 Warehouse</option>
                <option value="Commercial - Shop">🛍️ Shop</option>
                <option value="Commercial - Industrial Land">🏭 Industrial Land</option>
                <option value="Commercial - Building">🏢 Building</option>
                <option value="Commercial - Showroom">🎪 Showroom</option>
              </optgroup>
            </select>
          </div>

          <!-- City -->
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">City</label>
            <select 
              [(ngModel)]="cityFilter" 
              (change)="setCityFilter($any($event.target).value)"
              class="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 bg-white text-gray-900 text-sm">
              <option value="all">All Cities</option>
              <option *ngFor="let city of availableCities()" [value]="city">{{ city }}</option>
            </select>
          </div>

          <!-- Country -->
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">Country</label>
            <select 
              [(ngModel)]="countryFilter" 
              (change)="setCountryFilter($any($event.target).value)"
              class="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white text-gray-900 text-sm">
              <option value="all">All Countries</option>
              <option *ngFor="let country of availableCountries()" [value]="country">{{ country }}</option>
            </select>
          </div>

          <!-- Sort By -->
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">Sort By</label>
            <select 
              [(ngModel)]="sortBy" 
              (change)="setSortBy($any($event.target).value)"
              class="w-full px-3 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white text-gray-900 text-sm">
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
              <option value="price-asc">Price: Low to High</option>
              <option value="price-desc">Price: High to Low</option>
              <option value="area-asc">Area: Small to Large</option>
              <option value="area-desc">Area: Large to Small</option>
              <option value="bedrooms">Most Bedrooms</option>
              <option value="bathrooms">Most Bathrooms</option>
            </select>
          </div>

          <!-- Advanced Filters Toggle -->
          <div class="pt-4 border-t">
            <button 
              (click)="toggleAdvancedFilters()"
              [attr.aria-label]="(showAdvancedFilters() ? 'Hide' : 'Show') + ' advanced filters'"
              class="w-full flex items-center justify-between px-4 py-2.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 rounded-lg font-semibold transition text-sm">
              <span>{{ showAdvancedFilters() ? 'Hide' : 'Show' }} Advanced</span>
              <svg class="w-4 h-4 transition-transform duration-300" [class.rotate-180]="showAdvancedFilters()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
          </div>

          <!-- Advanced Filters -->
          <div *ngIf="showAdvancedFilters()" class="space-y-4 pt-4 border-t animate-in slide-in-from-top duration-200">
            <!-- Price Range -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">💵 Price Range</label>
              <div class="grid grid-cols-2 gap-2">
                <input 
                  type="number" 
                  [(ngModel)]="minPrice"
                  placeholder="Min"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 text-gray-900 text-sm">
                <input 
                  type="number" 
                  [(ngModel)]="maxPrice"
                  placeholder="Max"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 text-gray-900 text-sm">
              </div>
            </div>

            <!-- Bedrooms -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">🛏️ Bedrooms</label>
              <div class="grid grid-cols-2 gap-2">
                <input 
                  type="number" 
                  [(ngModel)]="minBedrooms"
                  placeholder="Min"
                  min="0"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 text-sm">
                <input 
                  type="number" 
                  [(ngModel)]="maxBedrooms"
                  placeholder="Max"
                  min="0"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 text-sm">
              </div>
            </div>

            <!-- Bathrooms -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">🚿 Bathrooms</label>
              <div class="grid grid-cols-2 gap-2">
                <input 
                  type="number" 
                  [(ngModel)]="minBathrooms"
                  placeholder="Min"
                  min="0"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-gray-900 text-sm">
                <input 
                  type="number" 
                  [(ngModel)]="maxBathrooms"
                  placeholder="Max"
                  min="0"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-gray-900 text-sm">
              </div>
            </div>

            <!-- Area -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">📐 Area (m²)</label>
              <div class="grid grid-cols-2 gap-2">
                <input 
                  type="number" 
                  [(ngModel)]="minArea"
                  placeholder="Min"
                  min="0"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-gray-900 text-sm">
                <input 
                  type="number" 
                  [(ngModel)]="maxArea"
                  placeholder="Max"
                  min="0"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 text-gray-900 text-sm">
              </div>
            </div>

            <!-- Year Built -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">📅 Year Built</label>
              <div class="grid grid-cols-2 gap-2">
                <input 
                  type="number" 
                  [(ngModel)]="minYearBuilt"
                  placeholder="Min"
                  min="1800"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-900 text-sm">
                <input 
                  type="number" 
                  [(ngModel)]="maxYearBuilt"
                  placeholder="Max"
                  class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-gray-900 text-sm">
              </div>
            </div>

            <!-- Neighborhood -->
            <div *ngIf="availableNeighborhoods().length > 0">
              <label class="block text-sm font-semibold text-gray-700 mb-2">🏘️ Neighborhood</label>
              <select 
                [(ngModel)]="neighborhoodFilter"
                class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-gray-900 text-sm">
                <option value="all">All Neighborhoods</option>
                <option *ngFor="let neighborhood of availableNeighborhoods()" [value]="neighborhood">
                  {{ neighborhood }}
                </option>
              </select>
            </div>

            <!-- Zone -->
            <div *ngIf="availableZones().length > 0">
              <label class="block text-sm font-semibold text-gray-700 mb-2">🗺️ Zone</label>
              <select 
                [(ngModel)]="zoneFilter"
                class="w-full px-3 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 text-gray-900 text-sm capitalize">
                <option value="all">All Zones</option>
                <option *ngFor="let zone of availableZones()" [value]="zone" class="capitalize">
                  {{ zone }}
                </option>
              </select>
            </div>

            <!-- Amenities Section -->
            <div class="pt-3 border-t">
              <label class="block text-sm font-semibold text-gray-700 mb-3">✨ Amenities</label>
              <div class="space-y-2">
                <!-- Elevator -->
                <div class="flex items-center justify-between">
                  <label class="text-sm text-gray-700">Elevator</label>
                  <select 
                    [(ngModel)]="hasElevatorFilter"
                    class="px-3 py-1.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 text-sm">
                    <option [ngValue]="null">Any</option>
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>

                <!-- Parking -->
                <div class="flex items-center justify-between">
                  <label class="text-sm text-gray-700">Parking</label>
                  <select 
                    [(ngModel)]="hasParkingFilter"
                    class="px-3 py-1.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 text-sm">
                    <option [ngValue]="null">Any</option>
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>

                <!-- Furnished -->
                <div class="flex items-center justify-between">
                  <label class="text-sm text-gray-700">Furnished</label>
                  <select 
                    [(ngModel)]="isFurnishedFilter"
                    class="px-3 py-1.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 text-sm">
                    <option [ngValue]="null">Any</option>
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>

                <!-- Terrace -->
                <div class="flex items-center justify-between">
                  <label class="text-sm text-gray-700">Terrace</label>
                  <select 
                    [(ngModel)]="hasTerraceFilter"
                    class="px-3 py-1.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 text-sm">
                    <option [ngValue]="null">Any</option>
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>

                <!-- Garden -->
                <div class="flex items-center justify-between">
                  <label class="text-sm text-gray-700">Garden</label>
                  <select 
                    [(ngModel)]="hasGardenFilter"
                    class="px-3 py-1.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 text-sm">
                    <option [ngValue]="null">Any</option>
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>

                <!-- View -->
                <div class="flex items-center justify-between">
                  <label class="text-sm text-gray-700">Has View</label>
                  <select 
                    [(ngModel)]="hasViewFilter"
                    class="px-3 py-1.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 text-sm">
                    <option [ngValue]="null">Any</option>
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </aside>

      <!-- Main Content Area -->
      <main class="flex-1 min-w-0">
        <!-- Skeleton Loading State -->
        <div *ngIf="loading()" class="animate-pulse space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            <div *ngFor="let i of [1,2,3,4,5,6]" class="bg-white rounded-lg overflow-hidden shadow-md">
              <!-- Image skeleton -->
              <div class="h-56 bg-gray-200"></div>
              <div class="p-5 space-y-3">
                <!-- Property type badge -->
                <div class="h-4 bg-gray-200 rounded w-20"></div>
                <!-- Title -->
                <div class="h-5 bg-gray-200 rounded w-3/4"></div>
                <!-- Address -->
                <div class="h-3 bg-gray-200 rounded w-full"></div>
                <!-- Price -->
                <div class="h-7 bg-gray-200 rounded w-1/2 mb-3"></div>
                <!-- Feature list -->
                <div class="space-y-2">
                  <div class="h-6 bg-gray-200 rounded w-full"></div>
                  <div class="h-6 bg-gray-200 rounded w-3/4"></div>
                  <div class="h-6 bg-gray-200 rounded w-2/3"></div>
                </div>
                <!-- Badges -->
                <div class="flex gap-1.5 mt-3">
                  <div class="h-5 bg-gray-200 rounded w-16"></div>
                  <div class="h-5 bg-gray-200 rounded w-16"></div>
                  <div class="h-5 bg-gray-200 rounded w-16"></div>
                </div>
                <!-- Button -->
                <div class="h-10 bg-gray-200 rounded w-full mt-3"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Error State -->
        <div *ngIf="error() && !loading()" class="bg-red-50 border border-red-200 rounded-lg p-4">
          <p class="text-red-700">{{ error() }}</p>
        </div>

        <!-- No Results -->
        <div *ngIf="!loading() && !error() && filteredProperties.length === 0" class="flex items-center justify-center py-20">
          <div class="max-w-md w-full">
            <div class="bg-white rounded-2xl shadow-xl p-12 text-center border border-gray-100">
              <!-- Icon with gradient background -->
              <div class="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-2xl flex items-center justify-center">
                <svg class="w-12 h-12 text-immovea-navy" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                </svg>
              </div>
              
              <!-- Message -->
              <h3 class="text-2xl font-bold text-gray-900 mb-3">No properties found</h3>
              <p class="text-gray-600 mb-8 leading-relaxed">We couldn't find any properties matching your criteria. Try adjusting your filters to discover more options.</p>
              
              <!-- Action Button -->
              <button 
                (click)="clearFilters()"
                aria-label="Clear all filters and show all properties"
                class="inline-flex items-center gap-2 px-8 py-3.5 bg-gradient-to-r from-immovea-navy to-blue-700 text-white rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-200 font-semibold">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                </svg>
                Clear All Filters
              </button>
            </div>
          </div>
        </div>

        <!-- Properties Grid -->
        <div *ngIf="!loading() && filteredProperties.length > 0" class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          <div *ngFor="let property of paginatedProperties; let propIdx = index" class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex flex-col">
            <!-- Image Container -->
            <div class="relative h-56 bg-gray-200 overflow-hidden group">
              <!-- Main Image -->
              <img
                *ngIf="getPropertyImageUrl(property, propIdx)"
                [src]="getPropertyImageUrl(property, propIdx)"
                [alt]="getPropertyImages(property)[propertyImageIndices[propIdx] || 0]?.alt_text || property.title"
                class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div *ngIf="!getPropertyImageUrl(property, propIdx)" class="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-300 to-gray-400">
                <span class="text-gray-600 text-sm font-medium">No image available</span>
              </div>
              
              <!-- Image Navigation -->
              <div *ngIf="getPropertyImages(property).length > 1" class="absolute inset-0 flex items-center justify-between px-2 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all">
                <button 
                  (click)="previousPropertyImage(propIdx, $event)"
                  aria-label="Previous property image"
                  class="bg-white bg-opacity-70 hover:bg-opacity-100 text-gray-900 rounded-full w-7 h-7 flex items-center justify-center transition text-lg">
                  ‹
                </button>
                <button 
                  (click)="nextPropertyImage(propIdx, $event)"
                  aria-label="Next property image"
                  class="bg-white bg-opacity-70 hover:bg-opacity-100 text-gray-900 rounded-full w-7 h-7 flex items-center justify-center transition text-lg">
                  ›
                </button>
              </div>
              
              <!-- Image Counter -->
              <div *ngIf="getPropertyImages(property).length > 1" class="absolute bottom-2 right-2 bg-black bg-opacity-60 text-white px-2 py-0.5 rounded text-xs font-medium">
                {{ (propertyImageIndices[propIdx] || 0) + 1 }}/{{ getPropertyImages(property).length }}
              </div>
              
              <!-- Favorite Button -->
              <button 
                (click)="toggleFavorite(property.id, $event)"
                aria-label="Toggle favorite"
                class="absolute top-2 left-2 z-10 p-2 rounded-full bg-white/90 hover:bg-white shadow-lg transition-all duration-200 hover:scale-110"
                [class.bg-red-50]="isFavorite(property.id)">
                <svg 
                  class="w-5 h-5 transition-colors"
                  [class.fill-red-500]="isFavorite(property.id)"
                  [class.text-red-500]="isFavorite(property.id)"
                  [class.text-gray-400]="!isFavorite(property.id)"
                  [attr.fill]="isFavorite(property.id) ? 'currentColor' : 'none'"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </button>
              
              <!-- Badges -->
              <div class="absolute top-2 right-2 flex gap-1.5">
                <div class="bg-emerald-500 text-white px-2 py-0.5 rounded-full text-xs font-semibold flex items-center gap-1 shadow-md" *ngIf="property.add_to_homepage">
                  <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  Featured
                </div>
                <div class="bg-immovea-navy text-white px-2 py-0.5 rounded-full text-xs font-semibold capitalize shadow-md">
                  {{ property.listing_type }}
                </div>
              </div>
            </div>

            <!-- Content -->
            <div class="p-5 flex flex-col flex-grow">
              <!-- Property Type Badge -->
              <div class="inline-block px-2 py-0.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-xs font-bold rounded-md mb-2 self-start">
                {{ property.property_type }}
              </div>

              <!-- Title -->
              <h3 class="text-lg font-bold text-gray-900 mb-1.5 line-clamp-2 hover:text-immovea-navy transition">
                {{ property.title }}
              </h3>
              
              <!-- Address -->
              <p class="text-gray-600 text-xs mb-3 line-clamp-1 flex items-center gap-1">
                <svg class="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
                </svg>
                <span class="truncate">{{ propertyService.getFullAddress(property) }}</span>
              </p>

              <!-- Price -->
              <div class="text-2xl font-bold text-immovea-navy mb-3 pb-3 border-b border-gray-200">
                {{ propertyService.formatPrice(property.price, property.currency) }}
              </div>

              <!-- Key Features -->
              <div class="flex-grow">
              <div class="space-y-1.5 mb-3">
                <div *ngIf="property.bedrooms || property.bathrooms || property.area" class="flex items-center gap-2 text-xs text-gray-700 bg-blue-50 rounded px-2 py-1.5">
                  <svg class="w-3.5 h-3.5 text-blue-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                  </svg>
                  <span class="font-semibold">
                    <span *ngIf="property.bedrooms">{{ property.bedrooms }} Bed<span *ngIf="property.bedrooms > 1">s</span></span>
                    <span *ngIf="property.bedrooms && property.bathrooms"> • </span>
                    <span *ngIf="property.bathrooms">{{ property.bathrooms }} Bath<span *ngIf="property.bathrooms > 1">s</span></span>
                    <span *ngIf="(property.bedrooms || property.bathrooms) && property.area"> • </span>
                    <span *ngIf="property.area">{{ property.area | number:'1.0-0' }} m²</span>
                  </span>
                </div>
                <div *ngIf="property.year_built" class="flex items-center gap-2 text-xs text-gray-700 bg-slate-50 rounded px-2 py-1.5">
                  <svg class="w-3.5 h-3.5 text-slate-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                  </svg>
                  <span class="font-semibold">Built {{ property.year_built }}</span>
                </div>
                <div *ngIf="property.parking_covered || property.parking_outdoor" class="flex items-center gap-2 text-xs text-gray-700 bg-indigo-50 rounded px-2 py-1.5">
                  <svg class="w-3.5 h-3.5 text-indigo-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"/>
                    <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"/>
                  </svg>
                  <span class="font-semibold">{{ (property.parking_covered || 0) + (property.parking_outdoor || 0) }} Parking Spot<span *ngIf="(property.parking_covered || 0) + (property.parking_outdoor || 0) > 1">s</span></span>
                </div>
                <div *ngIf="property.is_furnished" class="flex items-center gap-2 text-xs text-gray-700 bg-amber-50 rounded px-2 py-1.5">
                  <svg class="w-3.5 h-3.5 text-amber-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z"/>
                  </svg>
                  <span class="font-semibold">Fully Furnished</span>
                </div>
              </div>

              <!-- Additional Amenities Badges -->
              <div class="flex flex-wrap gap-1.5 mb-3">
                <span *ngIf="property.has_elevator" class="inline-block px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs font-semibold">
                  Elevator
                </span>
                <span *ngIf="property.has_terrace" class="inline-block px-2 py-0.5 bg-cyan-100 text-cyan-700 rounded text-xs font-semibold">
                  Terrace
                </span>
                <span *ngIf="property.has_garden" class="inline-block px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs font-semibold">
                  Garden
                </span>
                <span *ngIf="property.has_view" class="inline-block px-2 py-0.5 bg-teal-100 text-teal-700 rounded text-xs font-semibold">
                  View
                </span>
                <span *ngIf="property.has_generator" class="inline-block px-2 py-0.5 bg-yellow-100 text-yellow-700 rounded text-xs font-semibold">
                  Generator
                </span>
                <span *ngIf="property.general_condition" class="inline-block px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded text-xs font-semibold capitalize">
                  {{ property.general_condition.replace('_', ' ') }}
                </span>
              </div>
              </div>

              <!-- View Button -->
              <a 
                [routerLink]="['/property', property.id]"
                [attr.aria-label]="'View details for ' + property.title"
                class="block w-full px-4 py-2.5 bg-immovea-navy text-white text-center rounded-lg hover:bg-blue-900 transition font-semibold text-sm">
                View Details
              </a>
            </div>
          </div>
        </div>

        <!-- Pagination Controls -->
        <app-pagination
          *ngIf="!loading() && filteredProperties.length > 0"
          class="mt-8 block"
          [currentPage]="currentPage()"
          [totalItems]="filteredProperties.length"
          [itemsPerPage]="itemsPerPage"
          [itemName]="'properties'"
          (pageChange)="goToPage($event)">
        </app-pagination>
      </main>
    </div>
  </div>
</div>
